import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { useSiteContent, trackEvent } from '../context/SiteContext';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { settings } = useSiteContent();
  const phone = settings?.contactPhone || '+49 179 3912947';

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) { element.scrollIntoView({ behavior: 'smooth' }); setIsMenuOpen(false); }
  };

  const handleCallClick = () => { trackEvent('call_click'); };

  return (
    <header className="header" data-testid="header">
      <div className="container">
        <div className="header-content">
          <div className="logo"><h1 className="logo-text">BD Event Location</h1></div>
          <nav className={`navigation ${isMenuOpen ? 'navigation-open' : ''}`}>
            <button className="nav-link" onClick={() => scrollToSection('vorteile')}>Vorteile</button>
            <button className="nav-link" onClick={() => scrollToSection('prozess')}>Ablauf</button>
            <button className="nav-link" onClick={() => scrollToSection('kontakt')}>Kontakt</button>
            <a href={`tel:${phone}`} className="nav-phone" onClick={handleCallClick} data-testid="header-phone">
              <Phone size={16} /> {phone}
            </a>
          </nav>
          <button className="mobile-menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu">
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
